import Components from './components';
import Views from './views';

export default {
  Components,
  Views,
};
